import { connect } from 'react-redux';
import { readingActions } from '../../../actions';
import PageSpinner from '../../design/Episode/PageSpinner';

const mapState = state => ({
  ...state.reading.spinner
});

const mapDispatch = dispatch => ({
  spinnerHide: () => { dispatch(readingActions.spinnerHide()); },
  spinnerShow: () => { dispatch(readingActions.spinnerShow()); }
});

export default connect(mapState, mapDispatch)(PageSpinner);
